'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarLink = renderWithRef('PriceBarLink', null, (n, o)=>{
    let { children: t } = n;
    return jsx(RenderComp, {
        root: "button",
        forwardedRef: o,
        classNames: new Set([
            'swan-price-bar-main-link'
        ]),
        props: n,
        children: t
    });
});

export { PriceBarLink };
